'use strict';

const React = require('react');

function _interopNamespace(e) {
    if (e && e.__esModule) return e;
    const n = Object.create(null, { [Symbol.toStringTag]: { value: 'Module' } });
    if (e) {
        for (const k in e) {
            if (k !== 'default') {
                const d = Object.getOwnPropertyDescriptor(e, k);
                Object.defineProperty(n, k, d.get ? d : {
                    enumerable: true,
                    get: () => e[k]
                });
            }
        }
    }
    n.default = e;
    return Object.freeze(n);
}

const React__namespace = /*#__PURE__*/_interopNamespace(React);

const SvgArrowResizeDiagonalRight = (props) => React__namespace.createElement(
  "svg",
  Object.assign({ xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 24 24", height: props.size, width: props.size }, props),
  React__namespace.createElement("path", { fill: "#2D2E2E", d: "m17.876 6.124-6.506-.566-1.845 1.846 6.498.573.573 6.498 1.846-1.846-.566-6.505ZM7.404 9.525l-1.846 1.846.566 6.505 6.505.566 1.846-1.846-6.499-.573-.572-6.498Z" })
);

module.exports = SvgArrowResizeDiagonalRight;
//# sourceMappingURL=ArrowResizeDiagonalRight.cjs.js.map
